// extracted by mini-css-extract-plugin
export default {"tx":"_89c916a2b8","line":"_4adb372854"};